<template>
  <div>
    <BaseButton primary outline small @click="edit"> Edit </BaseButton>
  </div>
</template>

<script>
import { funnelStagesClient } from '@/api/clients';

export default {
  props: {
    funnelStage: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    async update(data) {
      try {
        await funnelStagesClient.update(this.funnelStage.id, data);

        this.$emit('updated');

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    edit() {
      this.$modal.show({
        component: () => import('Components/FunnelStage/FunnelStageModal.vue'),
        props: {
          action: this.update,
          accountId: this.funnelStage.account_id,
          funnelStage: this.funnelStage,
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
